export const brand = {
  whatsapp: "523317156670",
  instagram: {
    handle: "@silverkan_petfood",
    url: "https://instagram.com/silverkan_petfood" // TODO: actualizar si la cuenta cambia de nombre en el relanzamiento
  },
  facebook: {
    label: "19H Pet Food",
    url: "https://www.facebook.com/19HPetfood"
  },
  direccion: "Km 1.7 Carretera Tototlán-Guadalajara, C.P. 47730, Tototlán, Jalisco",
  mapsUrl: "https://maps.app.goo.gl/SFrGA5KF9Sxop6478"
};

export function waLink(texto) {
  return `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent(texto)}`;
}
